import type { ReactNode } from 'react';

/**
 * Highlighter-pen styled stat — for "fresh today" measurements that should pop visually.
 * Amber/yellow swipe behind the value mimics a marker highlighting the new datapoint.
 */
export function HighlightedStat({
  label,
  value,
  unit,
  sub,
}: {
  label: string;
  value: ReactNode;
  unit?: string;
  sub?: ReactNode;
}) {
  return (
    <div className="border-l border-amber-300/60 pl-4">
      <div className="text-[10px] uppercase tracking-[0.2em] text-amber-300/80 font-mono mb-1">{label}</div>
      <div className="text-3xl font-light tabular-nums text-stone-950 inline-block">
        <span className="bg-amber-300/90 px-2 py-0.5 -mx-1 rounded-sm">
          {value}
          {unit && <span className="text-sm text-stone-700 ml-1 font-mono">{unit}</span>}
        </span>
      </div>
      {sub && <div className="text-xs text-amber-300/70 font-mono mt-2">{sub}</div>}
    </div>
  );
}
